/**
 *
 * ListFilters
 *
 */

import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import React from 'react'

import PrimaryAppbar from '../../Tab/PrimaryTab/PrimaryAppbar'
import PrimaryTab from '../../Tab/PrimaryTab/PrimaryTab'
import PrimaryTabs from '../../Tab/PrimaryTab/PrimaryTabs'
import PrimaryTabsContainer from '../../Tab/PrimaryTab/PrimaryTabsContainer'

const styles = theme => ({
  container: {
    backgroundColor: theme.colors.white,
    padding: theme.spacing(4),
  },
})

/* eslint-disable react/prefer-stateless-function */
class SimpleDetailPage extends React.Component {
  state = {
    value: 'one',
  }

  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
  handleChange = (event, value) => {
    this.setState({
      value,
    })
  }

  render() {
    const { classes } = this.props
    const { value } = this.state
    return (
      <div className={classes.root}>
        <Grid container>
          <Grid item xs={12}>
            <PrimaryAppbar position="static">
              <PrimaryTabs value={value}>
                <PrimaryTab
                  activeElement={value === 'one'}
                  textTransformUnset
                  onClick={event => {
                    this.handleChange(event, 'one', 'Forms')
                  }}
                  value="one"
                  label="Forms"
                />
                {/* <PrimaryTab activeElement={value === "two"} onClick={(event) => { this.handleChange(event, "two", "Registration Fees"); }} value="two" label="Registration Fees" />
                    <PrimaryTab activeElement={value === "three"} onClick={(event) => { this.handleChange(event, "three", "Merchandise"); }} value="three" label="Merchandise" />
                    <PrimaryTab activeElement={value === "four"} onClick={(event) => { this.handleChange(event, "four", "Discounts"); }} value="four" label="Discounts" />
                    <PrimaryTab activeElement={value === "five"} onClick={(event) => { this.handleChange(event, "five", "Fee Splits"); }} value="five" label="Fee Splits" />
                    <PrimaryTab activeElement={value === "six"} onClick={(event) => { this.handleChange(event, "six", "Custom Questions"); }} value="six" label="Custom Questions" />
                    <PrimaryTab activeElement={value === "seven"} onClick={(event) => { this.handleChange(event, "seven", "Form Display Templates"); }} value="seven" label="Form Display Templates" /> */}
              </PrimaryTabs>
            </PrimaryAppbar>
          </Grid>
          <Grid item xs={12} className={classes.container}>
            {value === 'one' && (
              <PrimaryTabsContainer>
                <div>add your detail page/component here</div>
              </PrimaryTabsContainer>
            )}
            {/* {value === 'two' && <PrimaryTabsContainer>Item Two</PrimaryTabsContainer>}
                {value === 'three' && <PrimaryTabsContainer>Item Three</PrimaryTabsContainer>}
                {value === 'four' && <PrimaryTabsContainer>Item Three</PrimaryTabsContainer>}
                {value === 'five' && <PrimaryTabsContainer>Item Three</PrimaryTabsContainer>}
                {value === 'six' && <PrimaryTabsContainer>Item Three</PrimaryTabsContainer>}
                {value === 'seven' && <PrimaryTabsContainer>Item Three</PrimaryTabsContainer>} */}
          </Grid>
        </Grid>
      </div>
    )
  }
}

SimpleDetailPage.defaultProps = {}
export default withStyles(styles)(SimpleDetailPage)
